import keyMirror from 'keymirror'

export default keyMirror({
  GET_SECTIONS_REQUEST: null,
  GET_SECTIONS_SUCCESS: null,
  GET_SECTIONS_FAILED: null,

  GET_SECTION_DETAIL_REQUEST: null,
  GET_SECTION_DETAIL_SUCCESS: null,
  GET_SECTION_DETAIL_FAILED: null,

  ADD_SECTION_REQUEST: null,
  ADD_SECTION_SUCCESS: null,
  ADD_SECTION_FAILED: null,

  UPDATE_SECTION_REQUEST: null,
  UPDATE_SECTION_SUCCESS: null,
  UPDATE_SECTION_FAILED: null,

  UPDATE_FILTER_SECTION_SUCCESS: null,

  GET_COMPONENTS_REQUEST: null,
  GET_COMPONENTS_SUCCESS: null,
  GET_COMPONENTS_FAILED: null,

  ADD_COMPONENT_REQUEST: null,
  ADD_COMPONENT_SUCCESS: null,
  ADD_COMPONENT_FAILED: null,

  UPDATE_COMPONENT_REQUEST: null,
  UPDATE_COMPONENT_SUCCESS: null,
  UPDATE_COMPONENT_FAILED: null,

  UPDATE_SECTION_LANGUAGES_SUCCESS: null,

  UPDATE_COMPONENT_TRANSLATION_REQUEST: null,
  UPDATE_COMPONENT_TRANSLATION_SUCCESS: null,
  UPDATE_COMPONENT_TRANSLATION_FAILED: null,

  GET_SYSTEM_SECTIONS_REQUEST: null,
  GET_SYSTEM_SECTIONS_SUCCESS: null,
  GET_SYSTEM_SECTIONS_FAILED: null
})
